var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    fill: "white",
    stroke: "#1C4DA1",
    strokeDasharray: "10 10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 45.84V56.08C58 56.5892 57.7977 57.0776 57.4376 57.4376C57.0776 57.7977 56.5892 58 56.08 58H27.92C27.4108 58 26.9224 57.7977 26.5624 57.4376C26.2023 57.0776 26 56.5892 26 56.08V45.84C26 45.3308 26.2023 44.8424 26.5624 44.4824C26.9224 44.1223 27.4108 43.92 27.92 43.92C28.4292 43.92 28.9176 44.1223 29.2776 44.4824C29.6377 44.8424 29.84 45.3308 29.84 45.84V54.16H54.16V45.84C54.16 45.3308 54.3623 44.8424 54.7224 44.4824C55.0824 44.1223 55.5708 43.92 56.08 43.92C56.5892 43.92 57.0776 44.1223 57.4376 44.4824C57.7977 44.8424 58 45.3308 58 45.84ZM40.6416 47.1984C40.82 47.3774 41.0319 47.5194 41.2653 47.6163C41.4987 47.7132 41.7489 47.7631 42.0016 47.7631C42.2543 47.7631 42.5045 47.7132 42.7379 47.6163C42.9713 47.5194 43.1832 47.3774 43.3616 47.1984L49.7616 40.7984C50.1223 40.4377 50.3249 39.9485 50.3249 39.4384C50.3249 38.9283 50.1223 38.4391 49.7616 38.0784C49.4009 37.7177 48.9117 37.5151 48.4016 37.5151C47.8915 37.5151 47.4023 37.7177 47.0416 38.0784L43.92 41.2V27.92C43.92 27.4108 43.7177 26.9224 43.3576 26.5624C42.9976 26.2023 42.5092 26 42 26C41.4908 26 41.0024 26.2023 40.6424 26.5624C40.2823 26.9224 40.08 27.4108 40.08 27.92V41.2L36.9584 38.0816C36.7798 37.903 36.5678 37.7613 36.3344 37.6647C36.1011 37.568 35.851 37.5183 35.5984 37.5183C35.0883 37.5183 34.5991 37.7209 34.2384 38.0816C34.0598 38.2602 33.9181 38.4722 33.8215 38.7056C33.7248 38.9389 33.6751 39.189 33.6751 39.4416C33.6751 39.9517 33.8777 40.4409 34.2384 40.8016L40.6416 47.1984Z",
    fill: "#333E48",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.fcb9ed440cd6b223883720688f1f10ef.svg";
export { ForwardRef as ReactComponent };